<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110 70">
    <path
      d="M27.8586 2.99777L2.96517 27.8695C-0.988391 31.8203 -0.988391 38.1855 2.96517 42.1363L27.8645 67.008C29.7829 68.9257 32.4011 70.0058 35.1243 70.0058H99.7691C105.42 70.0058 109.997 65.4716 109.997 59.8746V10.1312C109.997 4.5342 105.42 0 99.7691 0H35.1243C32.3953 0 29.7829 1.08012 27.8645 2.99777H27.8586ZM25.9402 35.0029C25.9402 38.2664 23.2695 40.9118 19.9748 40.9118C16.6802 40.9118 14.0095 38.2664 14.0095 35.0029C14.0095 31.7394 16.6802 29.094 19.9748 29.094C23.2695 29.094 25.9402 31.7394 25.9402 35.0029Z"
    />
    <path
      d="M46.8809 33.9463H38V16.1733H46.601C50.2397 16.1733 52.4789 17.8368 52.4789 20.7884C52.4789 22.9313 51.2077 24.3407 49.4525 24.8201C51.5926 25.2995 52.8871 27.0901 52.8871 29.1059C52.8871 32.1037 50.7237 33.9463 46.8809 33.9463ZM45.5048 20.1068H42.9857V23.2317H45.5048C46.7235 23.2317 47.3883 22.7292 47.3883 21.6952C47.3883 20.6613 46.7293 20.1068 45.5048 20.1068ZM45.8605 26.7377H42.9857V29.9666H45.8896C47.1375 29.9666 47.7731 29.464 47.7731 28.4012C47.7731 27.3385 47.085 26.7377 45.8663 26.7377H45.8605Z"
      fill="white"
    />
    <path d="M55.0703 16.1787H60.056V33.9516H55.0703V16.1787Z" fill="white" />
    <path
      d="M79.7342 22.0244H74.3636C73.8038 21.0945 72.7834 20.5631 71.413 20.5631C68.894 20.5631 67.3662 22.3017 67.3662 25.0222C67.3662 28.072 68.9464 29.7124 71.897 29.7124C73.6289 29.7124 74.9001 28.9037 75.6407 27.3673H70.6258V23.815H79.9383V28.6033C78.8712 31.2026 76.0955 34.0733 71.413 34.0733C65.9142 34.0733 62.3047 30.3419 62.3047 25.0222C62.3047 19.7024 65.8909 16 71.3897 16C75.9206 16 79.0228 18.322 79.7342 22.0244Z"
      fill="white"
    />
    <path
      d="M54.4615 44.6665C54.4615 49.8071 50.8228 53.5674 45.0966 53.5674H38V35.7944H45.0966C50.8228 35.7944 54.4615 39.4507 54.4615 44.6665ZM44.7176 49.2064C47.5923 49.2064 49.4 47.5949 49.4 44.6665C49.4 41.738 47.5923 40.0803 44.7176 40.0803H42.9857V49.2064H44.7176Z"
      fill="white"
    />
    <path
      d="M68.179 39.7514H61.6888V42.651H67.4151V46.4054H61.6888V49.6054H68.179V53.562H56.7031V35.7891H68.179V39.7457V39.7514Z"
      fill="white"
    />
    <path
      d="M81.994 50.6678H75.6321L74.6641 53.5674H69.4219L75.9645 35.7944H81.7141L88.2275 53.5674H82.962L81.994 50.6678ZM78.8101 41.1373L76.9033 46.8845H80.7461L78.8101 41.1373Z"
      fill="white"
    />
    <path
      d="M94.8451 35.7944V49.784H100.42V53.5674H89.8594V35.7944H94.8451Z"
      fill="white"
    />
  </svg>
</template>
